import { UPDATE_ADS_URL } from "src/constants"
import axios from "axios"

export const updateAd = async (adId, data) => {
  return await axios.put(`${UPDATE_ADS_URL}/${adId}`, data)
}
